<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3">
    <img src="/assets/images/channel-wizards/listing-icon2.webp" alt="" height="40" />
    <div>
      <h6 class="mb-0" i18n>Rates</h6>
      <div class="text-sm">
        <ng-container i18n
          >As mentioned previously in this connection wizard, rates will now need to be pushed from AdvanceCM to
          Airbnb.</ng-container
        >
        <br />
        <ng-container i18n
          >Until this is done, your availability will remain blocked and the connection will not be
          complete.</ng-container
        >
      </div>
    </div>
  </div>
  <div class="border-top p-4 d-flex gap-5">
    <div class="flex-fill">
      <div class="alert alert-secondary-warning2" *ngIf="!isRentalRatesReady">
        <ng-container i18n>The following rate information is still missing for this rental:</ng-container>
        <ul class="mb-0 mt-1">
          <li *ngFor="let item of ratesMissing">{{ item }}</li>
        </ul>
        <div class="mt-1" *ngIf="autoPushState === 'missing'" i18n>
          Rates will be pushed to Airbnb automatically as soon as this is added.
        </div>
      </div>
      <div class="alert alert-secondary-info d-flex align-items-center gap-2" *ngIf="autoPushState === 'pushing'">
        <i class="far fa-spinner fa-spin"></i>
        <ng-container i18n>Pushing your AdvanceCM rates to Airbnb…</ng-container>
      </div>
      <div class="alert alert-secondary-success" *ngIf="autoPushState === 'done'">
        <ng-container i18n>Your rates were pushed to Airbnb automatically</ng-container>
        <ng-container *ngIf="autoPushedRateName"> ({{ autoPushedRateName }})</ng-container>.
        <ng-container i18n>You can review the price settings below and push different rates at any time.</ng-container>
      </div>
      <div
        class="alert alert-secondary-warning2"
        *ngIf="(autoPushState === 'manual' || autoPushState === 'failed') && !isRatesPushed"
        i18n
      >
        Your rates could not be pushed automatically. Please review the sections below and use the Push Rates button to
        complete the connection.
      </div>
      <div class="alert alert-secondary-info" *ngIf="isRentalRatesReady && !isRatesPushed && !autoPushState">
        <ng-container i18n
          >Rates imported from Airbnb are pre-filled for this rental. Review them below, then push rates to Airbnb to
          confirm and complete the connection.</ng-container
        >
      </div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">1</div>
              <ng-container i18n>Price Settings Overview</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              Before creating rates to push to AirBnb let’s review where some of the values are set. Each connection
              details page has an option called “Price Settings” located in the Actions dropdown.
            </p>

            <img src="/assets/images/listing-wizards/airbnb/price-settings.png" alt="" class="w-75 mb-3" />
            <p i18n>You will be able to view the price settings imported from AirBnb on the following page.</p>

            <div class="d-flex align-items-center gap-3 mt-3">
              <div class="flex-fill"></div>
              <button class="btn btn-light-info" (click)="settings.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #settings>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">2</div>
              <ng-container i18n>Adjust Price Settings</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>The following items can be adjusted in your Price Settings window.</p>

            <ul>
              <li>
                <b i18n>Base Price</b>:
                <ng-container i18n
                  >This is the standard price that would apply if no rates were being pushed to AirBnb. Under most
                  circumstances you will be pushing a rate to AirBnb so this is not necessary to adjust from the price
                  settings window.</ng-container
                >
              </li>
              <li>
                <b i18n>Weekend Price</b>:
                <ng-container i18n
                  >This price will also not need to be set here. AdvanceCM rates allow you to push different rates for
                  specific days of the week. Weekend pricing will be set using AdvanceCM rates which we will cover
                  shortly.</ng-container
                >
              </li>
              <li>
                <b i18n>Weekly and Monthly Discount</b>:
                <ng-container i18n
                  >These settings will affect all bookings of 7 days or greater, and 30 days or greater for Monthly.
                  Simply add in the percentage discount you would like to apply for bookings that meet these minimum
                  lengths of stay and the discount will apply in AirBnb.</ng-container
                >
              </li>
              <li>
                <b i18n>Cleaning Fee and Security Deposit</b>:
                <ng-container i18n
                  >The only place where you can adjust these values is here in the Price Settings window.</ng-container
                >
              </li>
              <li>
                <b i18n>Extra Guest Fee and Guests Included</b>:
                <ng-container i18n
                  >Can only be adjusted in the Price Settings window. Please note that these fields will be optional
                  when creating rates to push to AirBnb but in order to change these values, you must change them under
                  Price Settings.</ng-container
                >
              </li>
              <li>
                <b i18n>Listing Currency</b>:
                <ng-container i18n>Can only be adjusted in the Price Settings window.</ng-container>
              </li>
            </ul>
            <p i18n>
              Please hit the Price Settings button below to verify the details that have been imported from AirBnb. You
              can make adjustments and hit Save or close the window after confirming the values are correct.
            </p>

            <div class="d-flex align-items-center gap-3 mt-3">
              <button class="btn btn-light-info" (click)="onPriceSettings()">
                <i class="fas fa-money-bill"></i> <ng-container i18n>Price Settings</ng-container>
              </button>
              <div class="flex-fill"></div>
              <button class="btn btn-light-info" (click)="addRates.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #addRates>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">3</div>
              <ng-container i18n>Add Rates</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              As mentioned previously in this connection wizard, rates will now need to be pushed from AdvanceCM to
              Airbnb. Until this is done, your availability will remain blocked and the connection will not be complete.
            </p>

            <p i18n>
              If you have already prepared rates which you want to push to Airbnb please hit Continue to proceed.
            </p>
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-light-info" (click)="onAddStandardRate()">
                <i class="far fa-plus"></i> <ng-container i18n>Add Standard Rate</ng-container>
              </button>
              <button class="btn btn-light-info" (click)="onAddDynamicRate()">
                <i class="far fa-plus"></i> <ng-container i18n>Add Dynamic Rate</ng-container>
              </button>
              <div class="flex-fill"></div>
              <button class="btn btn-light-info" (click)="pushRates.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #pushRates>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">4</div>
              <ng-container i18n>Push Rates</ng-container>
              <i class="far fa-check-circle text-success ml-2" *ngIf="isRatesPushed"></i>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              This section will push the rates prepared by you previously to Airbnb. After completing this step you
              should see both the availability and rates match with your Airbnb rates calendar.
            </p>

            <p i18n>
              After clicking the Push Rates button you will be asked to specify the AdvanceCM Rate Category and the
              Channel Rate Category.
            </p>

            <p i18n>Here is a quick explanation of both values.</p>

            <div class="text-semi-bold" i18n>AdvanceCM Rate Category:</div>
            <p i18n>
              This corresponds with the rate category you have created or selected when creating your rates in
              AdvanceCM.
            </p>

            <div class="text-semi-bold" i18n>Channel Rate Category:</div>
            <p i18n>
              This corresponds with the rate name in Airbnb. By default the name of this rate will be Standard, but it
              is possible that you have renamed the standard rate in Airbnb and you will instead see that rate plan name
              as an option.
            </p>
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-light-info" (click)="onPushRates()">
                <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>Push Rates</ng-container>
              </button>
              <div class="flex-fill"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="mt-3 d-flex align-items-center justify-content-between">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <button class="btn btn-secondary-info" (click)="next.emit()">
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
  </button>
</div>
